<template>
    <div class="px-2 md:px-4">
        <portal to="page-header">
            {{ $t('Scan terminal') }}
        </portal>

        <portal to="actions">
            <div class="flex flex-row-reverse">
                <back-button
                    :route-name="'players.index'"
                >{{ $t('Players List') }}</back-button>
            </div>
        </portal>

        <div>
            <qrcode-stream @decode="onDecode"></qrcode-stream>
        </div>
    </div>
</template>

<script>
import { QrcodeStream, QrcodeDropZone, QrcodeCapture } from 'vue-qrcode-reader';
import BackButton from '../../Components/BackButton';

export default {
    name: 'Scan',
    components: {
        QrcodeStream,
        QrcodeDropZone,
        QrcodeCapture,
        BackButton
    },
    methods: {
        onDecode (decodedString) {
            console.log(decodedString);
            this.$inertia.post(route('terminal.activate.scan').url(), {terminal_id: decodedString});
        }
    }
}
</script>

<style lang="sass" scoped>

</style>
